module.exports = __webpack_public_path__ + "static/media/search.91f6ec9b.svg";